

const initialState = {
    isLoading : false,
    errorMessage:'',
    users_Data:null,
    selectedUser:{},
    totalrows:0,

    showUpdateUserPasswordModalData: false,
    showDeleteUserModal: false
};
    
    const manageUsersReducer = (state = initialState, { type, payload }) => {
      switch (type) {
        
        case "GET_ALLUSERS_REQUEST":
        case "UPDATE_USER_REQUEST":
        case "DELETE_USER_REQUEST":
        case "DOWNLOAD_ALLUSERS_REQUEST":
            return {
                ...state,
                isLoading :true,
            };
        case "GET_ALLUSERS_SUCCESS":
            return {
                ...state,
                isLoading:false,
                users_Data:payload,
                totalrows:payload.totalRecord
            };
      
        case "UPDATE_USER_SUCCESS":            
            return{
                ...state,
                isLoading:false
            }   
            
        case "DELETE_USER_SUCCESS":
            return {
                ...state,
                isLoading: false,
            };

        case "DOWNLOAD_ALLUSERS_SUCCESS":            
            return{
                ...state,
                isLoading:false
            } 
             
        case "GET_ALLUSERS_FAILURE":
        case "UPDATE_USER_FAILURE":  
        case "DELETE_USER_FAILURE":
        case "DOWNLOAD_ALLUSERS_FAILURE": 
            return {
                ...state,
                isLoading:false,
                errorMessage:payload
            };
  
        case 'SHOW_UPDATEUSERPASSWORD_MODAL':
            return  { 
              ...state, 
              showUpdateUserPasswordModalData:payload
            };    
    
        case 'SHOW_DELETEUSER_MODAL': 
            return {
                ...state,
                showDeleteUserModal:payload
            }

        default:
          return state;
      }
    };
    
    export default manageUsersReducer;
    